/**
 * ASAP Preferences Deep-Link Handler
 * 
 * Runs on all pages to check for asap-edit query parameters.
 * If detected, redirects to the resource page while preserving the hash.
 * This allows external edit links (e.g., from SMS "text 99" flow) to deep-link
 * into the form edit mode from anywhere.
 */

(function() {
  'use strict';

  const url = new URL(window.location.href);
  const t = url.searchParams.get('t');
  const hash = url.searchParams.get('hash');

  if (t === 'asap-edit' && hash) {
    const resourcePagePath = '/resources/';

    if (!window.location.pathname.includes('resources')) {
      const newUrl = resourcePagePath + '?t=asap-edit&hash=' + encodeURIComponent(hash);
      window.location.href = newUrl;
    }
  }
})();
